import { render, staticRenderFns, recyclableRender, components } from "./search.vue?vue&type=template&id=eb1fb978&scoped=true&"
var renderjs
import script from "./search.vue?vue&type=script&lang=js&"
export * from "./search.vue?vue&type=script&lang=js&"
import style0 from "./search.vue?vue&type=style&index=0&id=eb1fb978&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX.4.08.2024040127/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb1fb978",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/search/search.vue"
export default component.exports